<template>
  <div class="property-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="propertyTypeLabel"><strong>{{ $t('involvedSummary.property.typeLabel') }}:</strong> {{ propertyTypeLabel }}</span>
      <span v-if="data.address"><strong>{{ $t('involvedSummary.property.addressLabel') }}:</strong> {{ data.address }}</span>
      <span v-if="data.reference"><strong>{{ $t('involvedSummary.property.referenceLabel') }}:</strong> {{ data.reference }}</span>
      <span v-if="data.description"><strong>{{ $t('involvedSummary.property.descriptionLabel') }}:</strong> {{ data.description }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertySummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    propertyTypeLabel() {
      const map = {
        casa: this.$t('involvedSummary.property.propertyType.house'),
        apartamento: this.$t('involvedSummary.property.propertyType.apartment'),
        comercio: this.$t('involvedSummary.property.propertyType.commerce'),
        terreno: this.$t('involvedSummary.property.propertyType.land'),
        outro: this.$t('involvedSummary.property.propertyType.other'),
      }
      return map[this.data.property_type] || this.data.property_type || ''
    },
  },
}
</script>
